import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Rect } from '@antv/g';
import { subObject } from '../utils/helper';
import { domainOf } from '../utils/scale';
import { brush } from './brushHighlight';
import { brushXRegion } from './brushXHighlight';
import { brushYRegion } from './brushYHighlight';
import { selectG2Elements, createDatumof, createValueof, useState, selectPlotArea, mergeState } from './utils';
export var AXIS_CLASS_NAME = 'axis';
export var AXIS_LINE_CLASS_NAME = 'axis-line';
export var AXIS_MAIN_CLASS_NAME = 'axis-main-group';
export var AXIS_HOT_AREA_CLASS_NAME = 'axis-hot-area';
function axesOf(container) {
  return container.getElementsByClassName(AXIS_CLASS_NAME);
}
function lineOf(axis) {
  return axis.getElementsByClassName(AXIS_LINE_CLASS_NAME)[0];
}
function mainGroupOf(axis) {
  return axis.getElementsByClassName(AXIS_MAIN_CLASS_NAME)[0];
}
// Use the bounds of main group of axis as the bounds of axis,
// get rid of grid and title.
function boundsOfAxis(axis) {
  return mainGroupOf(axis).getLocalBounds();
}
// Brush for vertical axis.
function verticalBrush(axis, _a) {
  var cross = _a.cross,
    offsetX = _a.offsetX,
    offsetY = _a.offsetY,
    style = __rest(_a, ["cross", "offsetX", "offsetY"]);
  var bounds = boundsOfAxis(axis);
  var axisLine = lineOf(axis);
  var _axisLine$getLocalBou = _slicedToArray(axisLine.getLocalBounds().min, 1),
    lineX = _axisLine$getLocalBou[0];
  var _bounds$min = _slicedToArray(bounds.min, 2),
    minX = _bounds$min[0],
    minY = _bounds$min[1];
  var _bounds$max = _slicedToArray(bounds.max, 2),
    maxX = _bounds$max[0],
    maxY = _bounds$max[1];
  var size = (maxX - minX) * 2;
  return {
    brushRegion: brushYRegion,
    hotZone: new Rect({
      className: AXIS_HOT_AREA_CLASS_NAME,
      style: Object.assign({
        // If it is not cross, draw brush in both side of axisLine,
        // otherwise the draw brush within bounds area.
        x: cross ? minX : lineX - size / 2,
        width: cross ? size / 2 : size,
        y: minY,
        height: maxY - minY
      }, style)
    }),
    extent: cross ?
    // If it is cross, the x range is ignored.
    function (x, y, x1, y1) {
      return [-Infinity, y, Infinity, y1];
    } : function (x, y, x1, y1) {
      return [Math.floor(minX - offsetX), y, Math.ceil(maxX - offsetX), y1];
    }
  };
}
// Brush for horizontal axis.
function horizontalBrush(axis, _a) {
  var offsetY = _a.offsetY,
    offsetX = _a.offsetX,
    _a$cross = _a.cross,
    cross = _a$cross === void 0 ? false : _a$cross,
    style = __rest(_a, ["offsetY", "offsetX", "cross"]);
  var bounds = boundsOfAxis(axis);
  var axisLine = lineOf(axis);
  var _axisLine$getLocalBou2 = _slicedToArray(axisLine.getLocalBounds().min, 2),
    lineY = _axisLine$getLocalBou2[1];
  var _bounds$min2 = _slicedToArray(bounds.min, 2),
    minX = _bounds$min2[0],
    minY = _bounds$min2[1];
  var _bounds$max2 = _slicedToArray(bounds.max, 2),
    maxX = _bounds$max2[0],
    maxY = _bounds$max2[1];
  var size = maxY - minY;
  return {
    brushRegion: brushXRegion,
    hotZone: new Rect({
      className: AXIS_HOT_AREA_CLASS_NAME,
      style: Object.assign({
        x: minX,
        width: maxX - minX,
        // If it is not cross, draw brush in both side of axisLine,
        // otherwise the draw brush within bounds area.
        y: cross ? minY : lineY - size,
        height: cross ? size : size * 2
      }, style)
    }),
    extent: cross ?
    // If it is cross, the y range is ignored.
    function (x, y, x1, y1) {
      return [x, -Infinity, x1, Infinity];
    } : function (x, y, x1, y1) {
      return [x, Math.floor(minY - offsetY), x1, Math.ceil(maxY - offsetY)];
    }
  };
}
export function brushAxisHighlight(root, _a) {
  var axesOf = _a.axes,
    elementsOf = _a.elements,
    pointsOf = _a.points,
    isHorizontal = _a.horizontal,
    datum = _a.datum,
    offsetY = _a.offsetY,
    offsetX = _a.offsetX,
    _a$reverse = _a.reverse,
    reverse = _a$reverse === void 0 ? false : _a$reverse,
    _a$state = _a.state,
    state = _a$state === void 0 ? {} : _a$state,
    emitter = _a.emitter,
    coordinate = _a.coordinate,
    rest = __rest(_a, ["axes", "elements", "points", "horizontal", "datum", "offsetY", "offsetX", "reverse", "state", "emitter", "coordinate"]);
  var elements = elementsOf(root);
  var axes = axesOf(root);
  var valueof = createValueof(elements, datum);
  var _useState = useState(state, valueof),
    setState = _useState.setState,
    removeState = _useState.removeState;
  var axisExtent = new Map();
  var brushStyle = subObject(rest, 'mask');
  // Only some of shape's points in all mask, it is selected.
  var brushed = function brushed(points) {
    return Array.from(axisExtent.values()).every(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 4),
        x = _ref2[0],
        y = _ref2[1],
        x1 = _ref2[2],
        y1 = _ref2[3];
      return points.some(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          x0 = _ref4[0],
          y0 = _ref4[1];
        return x0 >= x && x0 <= x1 && y0 >= y && y0 <= y1;
      });
    });
  };
  var scales = axes.map(function (d) {
    return d.attributes.scale;
  });
  var extentOf = function extentOf(D) {
    return D.length > 2 ? [D[0], D[D.length - 1]] : D;
  };
  var indexDomain = new Map();
  var initIndexDomain = function initIndexDomain() {
    indexDomain.clear();
    for (var i = 0; i < axes.length; i++) {
      var scale = scales[i];
      var _scale$getOptions = scale.getOptions(),
        domain = _scale$getOptions.domain;
      indexDomain.set(i, extentOf(domain));
    }
  };
  initIndexDomain();
  // Update element when brush changed.
  var updateElement = function updateElement(i, emit) {
    var selectedElements = [];
    var _iterator = _createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        var points = pointsOf(element);
        if (brushed(points)) {
          setState(element, 'active');
          selectedElements.push(element);
        } else setState(element, 'inactive');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    indexDomain.set(i, selectionOf(selectedElements, i));
    if (!emit) return;
    // Emit events.
    var selection = function selection() {
      if (!cross) return Array.from(indexDomain.values());
      var S = [];
      var _iterator2 = _createForOfIteratorHelper(indexDomain),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            index = _step2$value[0],
            domain = _step2$value[1];
          var scale = scales[index];
          var _scale$getOptions2 = scale.getOptions(),
            name = _scale$getOptions2.name;
          if (name === 'x') S[0] = domain;else S[1] = domain;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return S;
    };
    emitter.emit('brushAxis:highlight', {
      nativeEvent: true,
      data: {
        selection: selection()
      }
    });
  };
  var clearElement = function clearElement(emit) {
    var _iterator3 = _createForOfIteratorHelper(elements),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var element = _step3.value;
        removeState(element, 'active', 'inactive');
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    initIndexDomain();
    if (!emit) return;
    emitter.emit('brushAxis:remove', {
      nativeEvent: true
    });
  };
  var selectionOf = function selectionOf(selected, i) {
    var scale = scales[i];
    var _scale$getOptions3 = scale.getOptions(),
      name = _scale$getOptions3.name;
    var domain = selected.map(function (d) {
      var data = d.__data__;
      return scale.invert(data[name]);
    });
    return extentOf(domainOf(scale, domain));
  };
  // Distinguish between parallel coordinates and normal charts.
  var cross = axes.some(isHorizontal) && axes.some(function (d) {
    return !isHorizontal(d);
  });
  var handlers = [];
  var _loop = function _loop(i) {
    var axis = axes[i];
    var createBrush = isHorizontal(axis) ? horizontalBrush : verticalBrush;
    var _createBrush = createBrush(axis, {
        offsetY: offsetY,
        offsetX: offsetX,
        cross: cross,
        zIndex: 999,
        fill: 'transparent' // Make it interactive.
      }),
      hotZone = _createBrush.hotZone,
      brushRegion = _createBrush.brushRegion,
      extent = _createBrush.extent;
    axis.parentNode.appendChild(hotZone);
    var brushHandler = brush(hotZone, Object.assign(Object.assign({}, brushStyle), {
      reverse: reverse,
      brushRegion: brushRegion,
      brushended: function brushended(emit) {
        axisExtent.delete(axis);
        if (Array.from(axisExtent.entries()).length === 0) clearElement(emit);else updateElement(i, emit);
      },
      brushed: function brushed(x, y, x1, y1, emit) {
        axisExtent.set(axis, extent(x, y, x1, y1));
        updateElement(i, emit);
      }
    }));
    handlers.push(brushHandler);
  };
  for (var i = 0; i < axes.length; i++) {
    _loop(i);
  }
  var onRemove = function onRemove() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var nativeEvent = event.nativeEvent;
    if (nativeEvent) return;
    handlers.forEach(function (d) {
      return d.remove(false);
    });
  };
  var rangeOf = function rangeOf(domain, scale, axis) {
    var _domain = _slicedToArray(domain, 2),
      d0 = _domain[0],
      d1 = _domain[1];
    var maybeStep = function maybeStep(scale) {
      return scale.getStep ? scale.getStep() : 0;
    };
    var x = abstractOf(d0, scale, axis);
    var x1 = abstractOf(d1, scale, axis) + maybeStep(scale);
    if (isHorizontal(axis)) return [x, -Infinity, x1, Infinity];
    return [-Infinity, x, Infinity, x1];
  };
  var abstractOf = function abstractOf(x, scale, axis) {
    var _coordinate$getOption = coordinate.getOptions(),
      height = _coordinate$getOption.height,
      width = _coordinate$getOption.width;
    var scale1 = scale.clone();
    if (isHorizontal(axis)) scale1.update({
      range: [0, width]
    });else scale1.update({
      range: [height, 0]
    });
    return scale1.map(x);
  };
  var onHighlight = function onHighlight(event) {
    var nativeEvent = event.nativeEvent;
    if (nativeEvent) return;
    var selection = event.data.selection;
    for (var _i = 0; _i < handlers.length; _i++) {
      var domain = selection[_i];
      var handler = handlers[_i];
      var axis = axes[_i];
      if (domain) {
        var scale = scales[_i];
        handler.move.apply(handler, _toConsumableArray(rangeOf(domain, scale, axis)).concat([false]));
      } else {
        handler.remove(false);
      }
    }
  };
  emitter.on('brushAxis:remove', onRemove);
  emitter.on('brushAxis:highlight', onHighlight);
  return function () {
    handlers.forEach(function (d) {
      return d.destroy();
    });
    emitter.off('brushAxis:remove', onRemove);
    emitter.off('brushAxis:highlight', onHighlight);
  };
}
/**
 * @todo Support mask size.
 */
export function BrushAxisHighlight(options) {
  return function (target, _, emitter) {
    var container = target.container,
      view = target.view,
      viewOptions = target.options;
    var plotArea = selectPlotArea(container);
    var _plotArea$getBBox = plotArea.getBBox(),
      x0 = _plotArea$getBBox.x,
      y0 = _plotArea$getBBox.y;
    var coordinate = view.coordinate;
    return brushAxisHighlight(container, Object.assign({
      elements: selectG2Elements,
      axes: axesOf,
      offsetY: y0,
      offsetX: x0,
      points: function points(element) {
        return element.__data__.points;
      },
      horizontal: function horizontal(axis) {
        var _axis$attributes = axis.attributes,
          _axis$attributes$star = _slicedToArray(_axis$attributes.startPos, 2),
          sx = _axis$attributes$star[0],
          sy = _axis$attributes$star[1],
          _axis$attributes$endP = _slicedToArray(_axis$attributes.endPos, 2),
          ex = _axis$attributes$endP[0],
          ey = _axis$attributes$endP[1]; // attention, non-horizontal does not mean vertical
        // it may has a specific degree angle
        return sx !== ex && sy === ey;
      },
      datum: createDatumof(view),
      state: mergeState(viewOptions, ['active', ['inactive', {
        opacity: 0.5
      }]]),
      coordinate: coordinate,
      emitter: emitter
    }, options));
  };
}